export const CORNER_ELEMENT_BEFORE =
  "before:absolute before:w-6.25 before:h-6.25 before:rounded-full";

// before:-bottom-5 before:-left-11.25 before:shadow-corner-bottom-right

export const CORNER_ELEMENT_AFTER =
  "after:absolute after:w-6.25 after:h-6.25 after:rounded-full";

// after:-top-11.25 after:-right-5 after:shadow-corner-bottom-right
